import React from 'react';
import { Drawer, styled } from '@mui/material';
import { CustomerExportDrawerContent } from './CustomerExportDrawerContent';
import { ICustomerExportOperation } from 'components/customers/export/models';

const PREFIX = 'CustomerExportDrawer';

const classes = {
    paper: `${PREFIX}-paper`
};

const StyledDrawer = styled(Drawer)(({ theme }) => ({
    [`& .${classes.paper}`]: {
        width: '416px',
        paddingBottom: theme.spacing(10)
    }
}));

interface CustomerExportDrawerProps {
    onClose: () => void;
    operation?: ICustomerExportOperation;
}

export const CustomerExportDrawer: React.FC<CustomerExportDrawerProps> = props => {
    const { onClose, operation } = props;

    return (
        <StyledDrawer
            anchor="right"
            hideBackdrop
            open={!!operation}
            classes={{ paper: classes.paper }}
            disableScrollLock
            disableEnforceFocus
            sx={{ left: 'auto' }}
        >
            <CustomerExportDrawerContent operation={operation} onClose={onClose} />
        </StyledDrawer>
    );
};
